import { useEffect, useRef } from "react";

/**
 * Sposta il focus su un elemento al montaggio della schermata, così che dopo
 * una navigazione VoiceOver/tastiera ripartano da un punto logico (di solito il
 * titolo). Non introduce alcuna logica di gioco.
 */
export function useAutoFocus() {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus({ preventScroll: true });
    }
  }, []);
  return ref;
}
